// Core
import styled from 'styled-components';

export const ListContainer = styled.div`
  padding-bottom: 32px;
`;

export const Container = styled.div`
  margin-bottom: 32px;
  height: 100%;
`;
